import { BodyCell } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { ConnectedMetricValuePillWrapper } from '../../../../metrics/components/ConnectedMetricValuePill';
import { MetricUpdatedCellFormatter } from '../../../../metrics/components/MetricUpdatedCellFormatter';
import { StyledCellFormatter } from '../StyledCellWrapper';

export function MetricValueCell(): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function PlainTextCell(props: BodyCell.Props) {
        return <ConnectedMetricValuePillWrapper row={props.row}/>;
      }
  );
}

export function MetricUpdatedCell(): React.StatelessComponent<BodyCell.Props> {
  return MetricUpdatedCellFormatter();
}
